import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import templateReducer from './slices/template.slice';
import passTemplatesListReducer from './slices/templateList.slice';
import batchListReducer from './slices/batchList.slice';
import passListReducer from './slices/passList.slice';
import { templateApi } from './api/templateApi';
import { passApi } from './api/passApi';
import { accountApi } from './api/accountApi';
import templateErrorsReducer from './slices/templateErrors.slice';
import { eventApi } from './api/eventApi';
import { batchApi } from './api/batchApi';
import { dynamicFormApi } from './api/dynamicFormApi';
import { billingApi } from './api/billingApi';
import { onboardingApi } from './api/onboardingApi';
import { scanApi } from './api/scanApi';
import formReducer from './slices/form.slice';
import passReducer from './slices/pass.slice';
import { rtkQueryErrorLogger } from './middleware/rtkQueryErrorLogger';

export const store = configureStore({
  reducer: {
    template: templateReducer,
    form: formReducer,
    passTemplatesList: passTemplatesListReducer,
    templateErrors: templateErrorsReducer,
    batchList: batchListReducer,
    passList: passListReducer,
    pass: passReducer,
    [templateApi.reducerPath]: templateApi.reducer,
    [passApi.reducerPath]: passApi.reducer,
    [accountApi.reducerPath]: accountApi.reducer,
    [eventApi.reducerPath]: eventApi.reducer,
    [batchApi.reducerPath]: batchApi.reducer,
    [dynamicFormApi.reducerPath]: dynamicFormApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [scanApi.reducerPath]: scanApi.reducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      templateApi.middleware,
      accountApi.middleware,
      eventApi.middleware,
      batchApi.middleware,
      dynamicFormApi.middleware,
      billingApi.middleware,
      passApi.middleware,
      onboardingApi.middleware,
      scanApi.middleware,
      rtkQueryErrorLogger
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);

const isWindowAvailable = typeof window !== 'undefined';
const runtimeEnv = isWindowAvailable
  ? (window as Window & { env?: { REACT_APP_ENV?: string } }).env?.REACT_APP_ENV
  : undefined;
const appEnv = process.env.REACT_APP_ENV || runtimeEnv;

if (process.env.NODE_ENV !== 'production' || appEnv === 'staging') {
  (window as Window & { __store?: typeof store }).__store = store;
}
